/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Appointment } from './appointment';
import { Attendance } from './attendance';
import { CasePlanTask } from './case-plan-task';
import { Program } from './program';
import { Probationer } from './probationer';
import { ProgramReferralStatusHistory } from './program-referral-status-history';
import { ReferralContactAttempt } from './referral-contact-attempt';


export interface ProgramReferral { 
    age?: number;
    anger?: string;
    appointments?: Set<Appointment>;
    attendances?: Set<Attendance>;
    casePlanTasks?: Set<CasePlanTask>;
    cellPhone?: string;
    cityStateZip?: string;
    cognitiveBehavioral?: string;
    compasSnapshotVersion?: number;
    contactAttempts?: Set<ReferralContactAttempt>;
    courtOrdered?: boolean;
    createdDate?: string;
    criminalAssociatesPeers?: string;
    criminalInvolvement?: string;
    criminalOpportunity?: string;
    criminalPersonality?: string;
    criminalThinkingSelfReport?: string;
    currentViolence?: string;
    dateOfBirth?: string;
    email?: string;
    estimatedReleaseDate?: string;
    ethnicity?: string;
    familyCriminality?: string;
    financial?: string;
    firstName?: string;
    fullName?: string;
    gender?: string;
    generalRecidivismRisk?: string;
    guardianCityStateZip?: string;
    guardianEmail?: string;
    guardianName?: string;
    guardianPhone?: string;
    guardianPrimaryLanguage?: string;
    guardianStreet?: string;
    historyofNonCompliance?: string;
    historyofViolence?: string;
    id?: string;
    isAdult?: boolean;
    isArsonist?: boolean;
    isSexOffender?: boolean;
    lastModified?: string;
    lastName?: string;
    legalStatus?: string;
    leisureandRecreation?: string;
    pcmsKey?: number;
    pcmsReferralId?: number;
    phone?: string;
    poEmail?: string;
    poName?: string;
    poPcmsKey?: number;
    poPhone?: string;
    pretrialReleaseRisk?: string;
    primaryLanguage?: string;
    probationStatus?: string;
    probationer?: Probationer;
    program?: Program;
    referralDate?: string;
    referralStatus?: ProgramReferral.ReferralStatusEnum;
    referralStatusDate?: string;
    rejectNotes?: string;
    rejectReason?: string;
    residentialInstability?: string;
    riskLevel?: string;
    screenerName?: string;
    screeningDate?: string;
    socialAdjustmentProblems?: string;
    socialEnvironment?: string;
    socialIsolation?: string;
    socializationFailure?: string;
    ssn?: string;
    statusHistories?: Set<ProgramReferralStatusHistory>;
    street?: string;
    substanceAbuse?: string;
    supervisionEndDate?: string;
    systemRecSupervisionLevel?: string;
    version?: number;
    violentRecidivismRisk?: string;
    vocationalEducation?: string;
}
export namespace ProgramReferral {
    export const ReferralStatusEnum = {
        Pending: 'PENDING',
        Accepted: 'ACCEPTED',
        Active: 'ACTIVE',
        Completed: 'COMPLETED',
        Cancelled: 'CANCELLED',
        Rejected: 'REJECTED',
        Removed: 'REMOVED'
    } as const;
    export type ReferralStatusEnum = typeof ReferralStatusEnum[keyof typeof ReferralStatusEnum];
}


